import MoreVertIcon from '@material-ui/icons/MoreVert';
import DescriptionIcon from '@material-ui/icons/Description';

export const TEMPLATE_TYPES = {
  messageMeetingCombo: 'messageMeetingCombo',
  facet: 'Facet Templates',
  outOfOffice: 'outOfOffice',
  note: 'note',
};

export const TEMPLATE_MENU_ICON_OPTIONS = {
  default: MoreVertIcon,
  description: DescriptionIcon,
};
